import React, {memo} from "react";
import AppModal from "../AppModal";
import {useHistory} from "react-router-dom";
import BottomShine from '../../assets/img/subject_underline_shine_effect.png'
import MessageIcon from "../../assets/img/help-popup-icon1cr2.png";
import PhoneIcon from "../../assets/img/help-popup-icon2cr.png";


function HelpdeskModal(props) {
    const history = useHistory();

    const { modalIsOpen, closeModal } = props;
    return (
        <div id="bg">
            <AppModal
                isOpen={modalIsOpen}
                handleCloseModal={closeModal}
                contents={
                    <div className={'modal-content-help'}>
                        <div className={'modal-header'}>
                            <h4 style={{fontSize: '1.6vw', margin: 7}}>Help</h4>
                            <div className={'close-button-help'} onClick={closeModal}>X</div>
                        </div>
                        <div style={{display: 'flex', width: '140%'}}>
                            <img src={BottomShine} style={{height: 5, width: '100%'}} alt={''}/>
                        </div>
                        <div className={'modal-body help-popup'}>

                            <div style={{fontSize: '1.1vw', color: '#fff', marginBottom: 25}}>
                                You may reach out to our live technical support team<br/> if you are experiencing any
                                issues.
                            </div>

                            <div className={'help-contacts-box'}>
                                <div className={'help-contacts-p'} style={{marginBottom: '15px'}}>
                                    <img style={{marginRight: '10px', width: '3.1vw', height: '3.1vw'}} src={MessageIcon}/>
                                    Email : help@trinax.sg
                                </div>
                                <div className={'help-contacts-p'}>
                                    <img style={{marginRight: '10px', width: '3.1vw', height: '3.1vw'}} src={PhoneIcon}/>
                                    Call   &nbsp;&nbsp;&nbsp;: 1800-222-8868 [Singapore users only]
                                </div>
                                <div className={'help-contacts-p'} >
                                    <div style={{ visibility: 'hidden'}}><img style={{marginRight: '10px',width: '3.1vw', height: '0.1vw'}} src={PhoneIcon}/>
                                        Call   &nbsp;&nbsp;&nbsp; :</div> +65-6694-8700 [Overseas users]
                                </div>
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    );
}

export default memo(HelpdeskModal);
